import { type ComponentProps, type FC } from "react";
import { RadioButton } from "@root/shared/components/RadioButton";
import * as styles from "./styles.css";

type Props = ComponentProps<typeof RadioButton>;

export const RadioWithLabel: FC<Props> = ({ id, label, checked, onChange, ...rest }) => {
  return (
    <label htmlFor={id} className={styles.label({ isSelected: checked })}>
      <RadioButton {...rest} checked={checked} id={id} onChange={onChange} />
      <span>{label}</span>
    </label>
  );
};
